import { render, staticRenderFns } from "./DocumentIndex.vue?vue&type=template&id=fa5b9cc4"
import script from "./DocumentIndex.vue?vue&type=script&lang=js"
export * from "./DocumentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports